import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.concat";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { schedulesShape } from 'redux/saga/entities/schedules.shape';
import createGoogleCalendarEventLink from 'helpers/createGoogleCalendarEventLink';
import shiftTimezone from 'tz-offsets';
import { SCHEDULE_SOURCE_MINDBODY } from 'constants/schedule-source';
import { TimeRange } from 'components/TimeRange/TimeRange';
import { MindBodyLink } from '../components/MindBodyLink';
import { RecommendedVenuesContainer } from '../components/RecommendedVenuesContainer';
import { mapScheduleProperties } from '../Reservation.helpers';
import { messages } from './ModalStates.messages';
export var Confirmation = function Confirmation(_ref) {
  var onModalClose = _ref.onModalClose,
      schedule = _ref.schedule;

  var _mapSchedulePropertie = mapScheduleProperties(schedule),
      description = _mapSchedulePropertie.description,
      klassName = _mapSchedulePropertie.klassName,
      endTime = _mapSchedulePropertie.endTime,
      venueId = _mapSchedulePropertie.venueId,
      address = _mapSchedulePropertie.address,
      locationName = _mapSchedulePropertie.locationName,
      venueName = _mapSchedulePropertie.venueName,
      startTime = _mapSchedulePropertie.startTime,
      timeZone = _mapSchedulePropertie.timeZone,
      source = _mapSchedulePropertie.source;

  return React.createElement("div", {
    className: "reservation"
  }, React.createElement("div", {
    className: "reservation__header"
  }, React.createElement(FormattedMessage, messages.confirmation)), React.createElement("div", {
    className: "reservation__class-name mb"
  }, klassName), React.createElement("div", {
    className: "reservation__venue"
  }, "".concat(venueName, " - ").concat(locationName)), React.createElement("div", {
    className: "reservation__date mt+ text--xl"
  }, React.createElement(FormattedDate, {
    value: shiftTimezone(startTime, timeZone) * 1000,
    weekday: "long",
    month: "long",
    day: "numeric"
  })), React.createElement("div", {
    className: "reservation__time mb text--xl"
  }, React.createElement(TimeRange, {
    startTimestamp: shiftTimezone(startTime, timeZone),
    endTimestamp: shiftTimezone(endTime, timeZone)
  })), React.createElement("p", {
    className: "mv"
  }, React.createElement("a", {
    href: createGoogleCalendarEventLink(klassName, description, address, startTime, endTime)
  }, React.createElement(FormattedMessage, messages.confirmationAddToCalendar))), React.createElement("button", {
    className: "bt bt--primary bt--solid bt--lg bt-done" // className="bt bt--primary bt--lg mb+"
    ,
    onClick: onModalClose
  }, React.createElement(FormattedMessage, messages.done)), React.createElement(RecommendedVenuesContainer, {
    venueId: venueId,
    venue: venueName
  }), source === SCHEDULE_SOURCE_MINDBODY && React.createElement("div", {
    className: "reservation--confirmation-mindbody"
  }, React.createElement(MindBodyLink, null)));
};
Confirmation.propTypes = {
  onModalClose: PropTypes.func.isRequired,
  schedule: schedulesShape
};